import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

import useAuthenthication from "../hooks/useAuthentication";
import { setUser } from "../redux/UserSlice";
import { resolveRole } from "../services/roles";

const AuthGuard = ({ children }: any) => {
  const token = useSelector((state: any) => state.UserSlice.accessToken);
  const user = useSelector((state: any) => state.UserSlice.user);
  const { logoutCall } = useAuthenthication();
  const dispatch = useDispatch();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAuthentication = async () => {
      if (!token) {
        setIsAuthenticated(false);
        return;
      }

      try {
        const decoded: any = jwtDecode(token);
        const isTokenExpired = Date.now() >= decoded.exp * 1000;

        if (isTokenExpired) {
          logoutCall();
        } else {
          const role = resolveRole(user?.role || decoded.role);
          if (user?.role !== role) {
            dispatch(
              setUser({
                user: {
                  ...user,
                  email: user?.email || decoded.username,
                  username: user?.username || decoded.username,
                  id: user?.id || decoded.sub,
                  role,
                },
                accessToken: token,
              })
            );
          }
          setIsAuthenticated(true);
        }
      } catch (error) {
        console.error("Invalid token or decoding failed:", error);
        setIsAuthenticated(false);
      }
    };

    checkAuthentication();
  }, [token]);

  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace />;
  }

  return <>{children}</>;
};

export default AuthGuard;
